import React from 'react';
import { TextInput } from '@abyss/web/ui/TextInput';
import { usePropsContext } from 'src/hooks/usePropsContext';
import { styled } from '@abyss/web/tools/styled';
import { formFormatterRegex } from '../../../resources/formFormatterRegex';

const StyledTextInput = styled(TextInput, {
  'input::-webkit-contacts-auto-fill-button': {
    visibility: 'hidden',
    display: 'none !important',
    pointerEvents: 'none',
    position: 'absolute',
    right: 0,
  },
});

export const FirstName = () => {
  const { notAllowNumeric } = formFormatterRegex;
  const { modelPrefix, onBlur } = usePropsContext();

  return (
    <StyledTextInput
      width="50%"
      data-testid="firstname"
      label="First name"
      model={`${modelPrefix}.firstName`}
      maxLength={50}
      formatter={value => {
        return value.replace(notAllowNumeric, '');
      }}
      onBlur={() => onBlur(`${modelPrefix}.firstName`)}
    />
  );
};
